module.exports = __webpack_public_path__ + "img/3.902cdb59.svg";